import box from 'assets/images/formFactors/box.png'
import bullet from 'assets/images/formFactors/bullet.png'
import covert from 'assets/images/formFactors/covert.png'
import cube from 'assets/images/formFactors/cube.png'
import dome from 'assets/images/formFactors/dome.png'
import ptz from 'assets/images/formFactors/ptz.png'
import turret from 'assets/images/formFactors/turret.png'
import multi_imager from 'assets/images/formFactors/multi-imager.png'

export default {
  box, bullet, covert, cube, dome, ptz, turret, multi_imager
}



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/Filter/formFactorImages.js